import { render, staticRenderFns } from "./UserPickerProject.vue?vue&type=template&id=44ab6364"
import script from "./UserPickerProject.vue?vue&type=script&lang=js"
export * from "./UserPickerProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ab6364')) {
      api.createRecord('44ab6364', component.options)
    } else {
      api.reload('44ab6364', component.options)
    }
    module.hot.accept("./UserPickerProject.vue?vue&type=template&id=44ab6364", function () {
      api.rerender('44ab6364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/UserPickerProject.vue"
export default component.exports